import { cachedClient } from './client.js';
import API from './API.js';

export { cachedClient, API };

const POST = 'POST';
const GET = 'GET';
export { GET, POST };
